import * as locales from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

import { type RepubConfig, REPUBS } from '@cx-modules/constants';

export const formatDate = (
  date: string,
  format: string = 'EEE, MMM d h:mm a zzz',
  repubConfig: RepubConfig = REPUBS.US,
  userTimezone?: string,
) => {
  const timezone = userTimezone || repubConfig.dateProperties.timezone;
  return formatInTimeZone(date, timezone, format, {
    locale:
      // TODO: @cx-modules/constants doesn't seem to pass the whole locale object including methods
      // so we need to review that. In the meantime, we'll just use the code to get the locale
      // should be able to just use the locale from @cx-modules/constants directly here but it throws an error
      locales[repubConfig.dateProperties.locale.code.replace('-', '') as keyof typeof locales],
  });
};
